export default __webpack_public_path__ + "static/media/stjosephbukittimah.56361b56.jpg";